import React, { useEffect, useMemo, useState } from "react";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { Box, Typography } from "@material-ui/core";
import { useRecoilValue } from "recoil";
import StarIcon from "@material-ui/icons/Star";
import moment from "moment";
import { checkinDetailSelector } from "Recoil/Checkins/selector";
import { useCheckinDetailGrid } from "Hooks/checkin/useCheckinDetailGrid";
import { useStyles } from "./styles";
import GridTable from "Components/GridTable";
import CustomColumnMenu from "Components/GridTable/customColumnMenu";
import { headerCell } from "src/utils/kendoGridFilter";
import UserProfileWidget from "Components/widgets/UserProfileWidget";
// import { UserGeneric } from "Modules/User/UserListing/ColumnListing";
import { KENDO_DATE_FORMAT } from "src/constants";
import { isArray } from "lodash";
import { imageGeneration } from "src/utils/emojiMapping";
import CheckRounded from "Assets/images/check.svg";
import CloseRounded from "Assets/images/close.svg";
import RequestFeedbackAttachments from "./Common/RequestFeedbackAttachments";

const ToggleTabContent = ({ data }) => {
  const classes = useStyles();
  const { toggleGridColumns } = useCheckinDetailGrid();
  const [columnsState, setColumnsState] = useState(toggleGridColumns);
  const { checkInType, isTestSurvey } = useRecoilValue(checkinDetailSelector);

  useEffect(() => {
    const questionHeader = ["name", "dueDate", "response"];
    if (data?.id === 1 && checkInType === "REQUESTFEEDBACK") {
      questionHeader.push("attachments");
    }
    const columns = toggleGridColumns.filter((c) =>
      questionHeader.includes(c.field)
    );
    setColumnsState(columns);
  }, []);

  const getText = (text) => {
    // if (data?.questionType === "EMOJIRANKING") {
    return (
      <img
        src={imageGeneration(text)}
        alt={text}
        className={classes.emojiImage}
      />
    );
    // }
    // return text;
  };

  const fetchUserColumn = (column, responseData) => {
    let columnObject = { ...column };
    let columnMenu = {
      columnMenu: (props) => (
        <CustomColumnMenu
          {...props}
          columns={columnObject}
          data={responseData}
          onColumnsSubmit={() => {}}
        />
      ),
    };
    switch (column.field) {
      case "name":
        columnObject = {
          ...column,
          ...columnMenu,
          cell: (colProps) => {
            return (
              <td>
                <Box display="flex" alignItems="center">
                  <Box position="relative">
                    <UserProfileWidget
                      firstName={colProps?.dataItem?.firstName}
                      lastName={colProps?.dataItem?.lastName}
                      url={colProps?.dataItem?.fileName}
                    />
                    {isTestSurvey && (
                      <span className={classes.userStatus}>
                        {colProps?.dataItem?.isCorrect ? (
                          <img src={CheckRounded} alt="correct" width="9px" />
                        ) : (
                          <img src={CloseRounded} alt="incorrect" width="8px" />
                        )}
                      </span>
                    )}
                  </Box>
                  <Typography
                    variant="body2"
                    className={`${
                      colProps?.dataItem?.userStatus ===
                      ("DEACTIVATED" || "REACTIVATED")
                        ? classes.deactivateUser
                        : ""
                    } font-13`}
                  >
                    {colProps?.dataItem?.fullName}
                  </Typography>
                </Box>
              </td>
            );
          },
        };
        break;
      case "dueDate":
        columnObject = {
          ...column,
          ...columnMenu,
          headerCell,
          cell: (colProps) => {
            return (
              <td className="text-center">
                {colProps?.dataItem?.responseDate
                  ? moment(colProps?.dataItem?.responseDate).format(
                      KENDO_DATE_FORMAT
                    )
                  : moment().format(KENDO_DATE_FORMAT)}
              </td>
            );
          },
        };
        break;
      case "response":
        columnObject = {
          ...column,
          cell: (colProps) => {
            return data?.questionType === "EMOJIRANKING" ? (
              <td>{getText(colProps?.dataItem?.response)}</td>
            ) : data?.questionType === "STARRANKING" ? (
              <>
                <td>
                  <Box display="flex">
                    {Array(parseInt(colProps?.dataItem?.response[0])).fill(
                      <StarIcon className={classes.starIcon} />
                    )}
                  </Box>
                </td>
              </>
            ) : (
              // <UserGeneric
              //   title={
              //     checkInType === "SURVEY"
              //       ? colProps.dataItem?.response
              //       : null
              //   }
              // />
              <td>
                <span
                  className="format-txt pre-wrap"
                  dangerouslySetInnerHTML={{
                    __html: [
                      "SURVEY",
                      "REQUESTFEEDBACK",
                      "SKILLRATING",
                    ].includes(checkInType)
                      ? `${colProps?.dataItem?.response}`
                      : "",
                  }}
                ></span>
                {/* <span className="pre-wrap">
                  {checkInType === "SURVEY"
                    ? colProps.dataItem?.response
                    : null}
                </span> */}
              </td>
            );
          },
        };
        break;
      case "attachments":
        columnObject = {
          ...column,
          ...columnMenu,
           headerCell,
          cell: (colProps) => {
            return (
              <td className="text-center">
                {colProps.dataItem.id === 1 && (
                  <RequestFeedbackAttachments
                    attachmentData={colProps.dataItem.attachments}
                    isDownload={true}
                  />
                )}
              </td>
            );
          },
        };
        break;
      default:
        columnObject = { ...column };
        break;
    }

    return <Column {...columnObject} width={columnObject.minWidth} />;
  };
  const updatedValueForSurvey = (item, data, allCheckinData) => {
    let response = item?.response; //|| item?.[0]?.response;
    let responses =
      isArray(response) && response?.length
        ? response?.join(", ")
        : response || "";
    if (
      !["EMOJIRANKING", "STARRANKING", "DESCRIPTIVE"].includes(
        allCheckinData?.questionType
      )
    ) {
      responses = (
        typeof response === "string"
          ? [response]
          : response
              ?.reduce((res, ele) => {
                const idx = allCheckinData?.options?.findIndex(
                  (r) => r.text.toLowerCase() === ele.toLowerCase()
                );
                const ansIdx = allCheckinData?.answer?.length
                  ? allCheckinData?.answer?.findIndex(
                      (r) => r.toLowerCase() === ele.toLowerCase()
                    )
                  : 0;
                res.push(
                  `${
                    ansIdx >= 0 ? "" : '<span class="incorrect-ans d-block">'
                  } ${String.fromCodePoint(65 + idx)}. ${ele} ${
                    ansIdx >= 0 ? "" : "</span>"
                  }`
                );
                // const ansIdx = item?.answer.findIndex((r) => r.toLowerCase() === ele.toLowerCase());
                // res.push(`${String.fromCodePoint(65 + idx)}. ${ele}`);
                return res;
              }, [])
              ?.sort()
      )?.join(" \n");
    }
    if (response) {
      const attachmentData = [];
      if (item?.requestFeedbackAttachments?.length > 0) {
        item?.requestFeedbackAttachments?.map((res) => {
          attachmentData.push(res.s3Link);
        });
      }
      if (item?.attachmentLink?.length > 0) {
        item?.attachmentLink.map((item) => {
          attachmentData.push(item);
        });
      }

      let user = item?.user || item?.rater;
      data.push({
        isCorrect: item?.isCorrect,
        fullName: `${user?.firstName} ${user?.lastName}`,
        firstName: user?.firstName,
        lastName: user?.lastName,
        fileName: user?.profileImage?.fileName,
        response: responses,
        responseDate: item?.responseDate || item?.[0]?.date,
        attachments: attachmentData,
        id: allCheckinData?.id,
      });
    }
  };
  const userResponseData = (allCheckinData) => {
    const data = [];
    allCheckinData?.userResponse?.map((item) => {
      if (Array.isArray(item)) {

        // item?.map((res) => return  updatedValueForSurvey(res, data, allCheckinData));
        item?.map((res) => {
          return updatedValueForSurvey(res, data, allCheckinData);
        });


      } else updatedValueForSurvey(item, data, allCheckinData);
    });
    return data;
  };
  const displaySubgrid = useMemo(
    () => (
      <GridTable
        data={userResponseData(data)}
        isPageable={true}
        sortable={false}
      >
        {columnsState.map(
          (column) =>
            column.show && fetchUserColumn(column, userResponseData(data))
        )}
      </GridTable>
    ),
    [userResponseData(data)?.length, columnsState?.length]
  );
  return <Box className={classes.surveySubTable}>{displaySubgrid}</Box>;
};

export default ToggleTabContent;
